import DocumentType from '@/enums/document-type.enum'

export interface LegacyDocumentScanActionOptions {
  useDocuAiEnabled?: boolean
  isCollaborationView?: boolean
  isUserTaxConsultant?: boolean
  isOfficeDocument?: boolean
  isCsv?: boolean
  isDesktop?: boolean
  isAssigned?: boolean
  /** Truthy when the file is a PDF carrying the incomingInvoice tag. */
  isIncomingInvoice?: unknown
  documentType?: string
}

// FLAG:useDocuAi — „Analyse" / „Erneut analysieren" in the Documents tile context menu.
// The entry opens the drawer with `analyze: true`, which triggers
// `DocumentAnalysisService.analyze()` there — the same action the drawer action menu has always
// hidden when the flag is ON (document-actions-button.tsx). It calls `GET /file/:id/analyze`, and
// that endpoint branches on the flag server-side (api/src/services/fileService/analyzeFile.js):
// with the flag ON, the click is therefore a genuine new DocuAI run through the legacy entry point,
// including scan usage. With the flag ON, retries belong in the document details (InvoiceReviewAnalysisActions / retryFailedAnalysis).
//
// All remaining terms are the unchanged legacy condition so flag-OFF remains byte-identical.
export const shouldShowLegacyDocumentScanAction = ({
  useDocuAiEnabled,
  isCollaborationView,
  isUserTaxConsultant,
  isOfficeDocument,
  isCsv,
  isDesktop,
  isAssigned,
  isIncomingInvoice,
  documentType,
}: LegacyDocumentScanActionOptions): boolean =>
  !useDocuAiEnabled
  && !isCollaborationView
  && !isUserTaxConsultant
  && !isOfficeDocument
  && !isCsv
  && !isDesktop
  && !isAssigned
  && !!isIncomingInvoice
  // An own outgoing invoice/cancellation is not an analysis candidate (unchanged legacy rule).
  && documentType !== DocumentType.INVOICE
  && documentType !== DocumentType.CANCELLATION
